import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { MatLabel } from '@angular/material/form-field';
import { MatSelect, MatSelectTrigger, MatOption } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { LineDashArrayViewComponent } from '../line-type-item/line-dash-array-view.component';

@Component({
  selector: 'app-line-type-selector',
  templateUrl: './line-type-selector.component.html',
  styleUrls: ['./line-type-selector.component.scss'],
  imports: [MatFormField, MatLabel, MatSelect, FormsModule, MatSelectTrigger, MatOption, LineDashArrayViewComponent],
})
export class LineTypeSelectorComponent implements OnChanges {
  @Input() dashArray: number[];
  @Output() dashArrayChange = new EventEmitter<number[]>();
  @Output() lineTypeChanged = new EventEmitter();

  lineTypes: number[][] = [
    undefined,
    [5, 4],
    [2, 4],
    [1, 4],
    [4, 5, 1, 5],
  ];
  readonly Math = Math;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dashArray']?.previousValue !== changes['dashArray']?.currentValue) {
      this.setDashArray();
    }
  }

  onChange(e: number[]) {
    this.dashArrayChange.emit(e);
    this.lineTypeChanged.emit();
  }

  private setDashArray() {
    this.dashArray = this.lineTypes.find(lineType => {
      return (lineType === undefined && this.dashArray === undefined) || lineType?.join(':::') === this.dashArray?.join(':::');
    });
  }
}
